module.exports = __webpack_public_path__ + "static/img/Principal.14d326cb.png";